<template>
  <div>
    <Header/>
    <div class="zwB "></div>
    <div class="bodyBG2">
      <div class="curBoxb">
        <BreadCrumb/>
      </div>
      <div class="zcglBa">
      </div>
      <div class="listPBa">
        <BusinessIntroductionLeftNav/>
        <div class="listPBr">
          <div class="docTitleB">
            <h1>
              {{$t('institutional_business')}}
            </h1>
            <div class="timeB">
              {{$t('belonging_to')}} {{$t('company_introductions')}} {{$t('author')}} {{$t('tajik_securities')}} {{$t('update_time')}}：2020-06-03 14:03:36
            </div>
          </div>
            <div class="docHtmlB">
              <div class="TRS_Editor">
                <p class="sub_tit">{{$t("institutional_business_one")}}</p><br />
                <p class="sub_tit">{{$t("institutional_business_two")}}</p><br/>
                <ul class="xin3list1 after">
                  <li>
                    <h3>{{$t("institutional_business_three_title")}}</h3>
                    <div>
                      {{$t("institutional_business_three_one")}}<br>
                      {{$t("institutional_business_three_two")}}
                    </div>
                  </li>
                  <li>
                    <h3>{{$t("institutional_business_four_title")}}</h3>
                    <div>
                      {{$t('institutional_business_four_one')}}<br>
                      {{$t('institutional_business_four_two')}}
                    </div>
                  </li>
                  <li>
                    <h3>{{$t("institutional_business_five_title")}}</h3>
                    <div>
                      {{$t("institutional_business_five_one")}}<br>
                      {{$t("institutional_business_five_two")}}<br>
                      {{$t("institutional_business_five_three")}}
                    </div>
                  </li>
                  <li>
                    <h3>{{$t("institutional_business_six_title")}}</h3>
                    <div>
                      {{$t('institutional_business_six_one')}}<br>
                      {{$t('institutional_business_six_two')}}
                    </div>
                  </li>
                </ul>
                <p class="sub_tit">{{$t('institutional_business_seven')}}</p>
              </div>
              <p class="docHtmlB"></p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import Footer from "../components/Footer";
  import Header from "../components/Header";
  import BusinessIntroductionLeftNav from "../components/BusinessIntroductionLeftNav";
  import BreadCrumb from "../components/BreadCrumb";

  export default {
    components: {BreadCrumb, BusinessIntroductionLeftNav, Footer, Header}
  }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
</style>
<style scoped>
    .zwB {
        height: 130px;
    }
    .TRS_Editor p{
        text-indent: 2em;
    }
    .xin3list1 h3 {
        font-size: 16px;
        line-height: 38px;
        font-weight: normal;
        background-color: #107ac1;
        color: #fff;
        text-align: center;
    }

    .xin3list1 div {
        overflow: auto;
        font-size: 14px;
        height: 260px;
        line-height: 180%;
        padding: 20px;
        border: 1px dashed #107ac1;
        border-top-width: 0;
        background-color: #fffafa;
        color: #333;
        text-align: left;
    }
    .xin3list1 div::-webkit-scrollbar{
        display: none;
        width: 0;
        height: 0;
    }
    .xin3list1 li {
        width: 210px;
        float: left;
        margin-right: 30px;
        margin-bottom: 30px;
    }
    .xin3list1{
        display: flex;
    }
</style>
